/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import swal from 'sweetalert';

document.addEventListener("DOMContentLoaded", function(event) {
  
  $("#search").click(function() {
    if($("#member_code").val() === ""){
        swal({
            title: "Debes ingresar un código válido",
            icon: "error",
            closeOnEsc: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            button: "Ok"
        });
    }else{
        $.ajax({
        url : $("#member_code").data("url"),
        data : { authenticity_token: $('meta[name="csrf-token"]').attr("content"), fullcode : $("#member_code").val() },
        type : 'POST',
        beforeSend: function( xhr ) {
            $("#result").html("Buscando...");
            $("#search i").removeClass("mdi-account-search").addClass("mdi-clock");
            $("#search").attr("disabled",true);
          },
        complete : function(xhr, status) {
           $("#search i").addClass("mdi-account-search").removeClass("mdi-clock");
           $("#search").removeAttr("disabled");
        }
    });
    }
    
  });
  
  
  
      /*
     * BEGIN: 
     * @type ScollDown
     * 
     */
    
        const elementPosition = $("header").offset();
        if($(window).scrollTop() >= 2)
            $("header").addClass('down');
         else 
        $("header").removeClass('down');
        $(window).scroll(function(){
            if($(window).scrollTop() >= 2)
                $("header").addClass('down');
             else 
                $("header").removeClass('down');
        });
    /*
     * END: 
     * @type ScollDown
     * 
     */
  
  
});